import React  from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import LeadActivityInfoComponent from './lead-activity-info.component';
import LeadDetailsInfoComponent from './lead-details-info.component';
import { AddressContainer } from '../../../../../../common/address/containers/address.container';


export const LeadComponent = ({ 
  handleInnerFormChange,selectLeadAddress,salutation,industryType,businessType,stateValues,countries,tagNames,salesSource,relatedToTypes,leadRating,leadStatus,selectedLead,back,taskStatus,handleFormSubmit
}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Lead Details',
        component:<LeadDetailsInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedLead={selectedLead}
        salutation={salutation}
        industryType={industryType}
        businessType={businessType}
        salesSource={salesSource}
        leadRating={leadRating}
        leadStatus={leadStatus}
        tagNames={tagNames}
       />,
    isVisible:true,
    },
    {
      id:2,
      title:'Address',
      component:<AddressContainer 
      handleInnerFormChange={handleInnerFormChange}
      selectedAddress={selectLeadAddress}
     />,
    isVisible:true,
    },
    // {
    //   id:3,
    //   title:'Activity Info',
    //   component:<LeadActivityInfoComponent 
    //   handleInnerFormChange={handleInnerFormChange}
    //   selectedLead={selectedLead}
    //   taskStatus={taskStatus}
    //   relatedToTypes={relatedToTypes}
    // />,
    // isVisible:true,
    // },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default LeadComponent;
